import React from 'react';
import { AlertTriangle, CheckCircle, Info, XCircle } from 'react-feather';
import { cx } from './cx';

export type CalloutTone = 'info' | 'success' | 'warning' | 'danger';

const ICONS: Record<CalloutTone, React.ReactNode> = {
  info: <Info size={18} aria-hidden />,
  success: <CheckCircle size={18} aria-hidden />,
  warning: <AlertTriangle size={18} aria-hidden />,
  danger: <XCircle size={18} aria-hidden />,
};

interface CalloutProps {
  tone?: CalloutTone;
  title?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

/**
 * Inline message that stays on the page: results of an action the user must read,
 * configuration problems, warnings before a step. Short-lived confirmations go in a toast.
 */
const Callout: React.FC<CalloutProps> = ({ tone = 'info', title, children, className }) => (
  <div className={cx('ds-callout', `ds-callout--${tone}`, className)} role={tone === 'danger' ? 'alert' : 'status'}>
    <span className="ds-callout__icon">{ICONS[tone]}</span>
    <div className="ds-callout__content">
      {title && <div className="ds-callout__title">{title}</div>}
      {children && <div className="ds-callout__body">{children}</div>}
    </div>
  </div>
);

export default Callout;
